import React from 'react';

function WrapperCell(props) {
    return (
        <>{props.cellData.cell(props)}</>
    );
}

export default WrapperCell;